// eslint-disable-next-line import/prefer-default-export
export const updateTokenInfoLS = (token: string, expiresIn: number) => {
  window.localStorage.setItem('token', token);
  window.localStorage.setItem('tokenExpiresIn', `${expiresIn}`);
  window.dispatchEvent(new Event('storage'));
};
